import $ from 'jquery';
import BaseUrlManager from './base-url-manager';
import List from './api-urls';
import {DEFAULT_LANGUAGE, LPSOLVER_URL} from 'config';

class APIManager extends BaseUrlManager {
    constructor(list) {
        super(list);
    }
    to(request, params = {}) {
        let url = super.to(request);

        if (!isEmpty(params)) {
            let query = $.param(params);
            url += '?' + query;
        }

        return url;
    }
    toLpSolver(params = {}) {
        const {version = '1'} = params;

        let path = 'RESOLVE_LINEUP';
        if (version === '2') {
            path = 'RESOLVE_LINEUP_V2';
        } else if (version === '3') {
            path = 'RESOLVE_LINEUP_V3';
        }
        
        return LPSOLVER_URL + this.to(path);
    }
    getBaseHeaders() {
        return {
            Accept: 'application/json',
            'Accept-Language': DEFAULT_LANGUAGE,
            'Time-Zone': new Date().getTimezoneOffset(),
        };
    }
}

const API = new APIManager(List);

export default API;
